var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopicVocales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DBEAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BFDBFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "letterGrad1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2563EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1D4ED8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "letterGrad2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1E40AF"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "url(#bgGrad)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(32, 32)",
    filter: "drop-shadow(0px 3px 2.5px rgba(29, 78, 216, 0.25))"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10, -3) rotate(-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: -12,
    width: 20,
    height: 24,
    rx: 4,
    fill: "url(#letterGrad1)",
    stroke: "#60A5FA",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 7,
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 20,
    fontWeight: 900,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "A")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11, -8) rotate(12)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -9,
    width: 16,
    height: 18,
    rx: 3.5,
    fill: "url(#letterGrad2)",
    stroke: "#93C5FD",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 5.5,
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 15,
    fontWeight: 900,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "E")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4, 12) rotate(-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -6,
    y: -7,
    width: 12,
    height: 14,
    rx: 3,
    fill: "#1D4ED8",
    stroke: "#3B82F6",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 4.5,
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 12,
    fontWeight: 900,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "I")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicVocales);
export default __webpack_public_path__ + "static/media/topic_vocales.2d23baa88dd101b3fa9faa002604bf12.svg";
export { ForwardRef as ReactComponent };